export default __webpack_public_path__ + "static/media/Ryoshi.77e633fb.png";